var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AdminOverview'),_vm._v(" "),_c('AdminUsage'),_vm._v(" "),_c('AdminActivity'),_vm._v(" "),_c('AdminBookingHistory'),_vm._v(" "),_c('AdminOffice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }